import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IdpConfigId } from '../auth/models/idp-config-id.enum';
import { AuthFacade } from '../auth/auth.facade';
import { ACTIVE_IDP_KEY } from '../auth/models/auth-storage-keys';
import { RemoteSessionCheckerService } from './remote-session-checker.service';

/**
 * Unified session checker — delegates to the checker that matches the active IdP:
 *  - 'oidc' → returns true immediately (no remote session check for CIAM)
 *  - 'okta' → RemoteSessionCheckerService (/api/v1/sessions/me)
 */
@Injectable({ providedIn: 'root' })
export class SessionCheckerService {
  private readonly authFacade = inject(AuthFacade);
  private readonly oktaChecker = inject(RemoteSessionCheckerService);

  isSessionActive(): Observable<boolean> {
    const storedIdp = sessionStorage.getItem(ACTIVE_IDP_KEY) as IdpConfigId | null;
    const configId = storedIdp ?? this.authFacade.activeConfigId();

    if (configId === IdpConfigId.Oidc) {
      return of(true);
    }

    if (configId === IdpConfigId.Okta) {
      return this.oktaChecker.isSessionActive();
    }

    return of(false);
  }
}
